import React from "react";
import { IconProps } from "./types";
import { Image } from "../Image/Image";

export const Icon = (props: IconProps) => {
    return Image(props);
}
Icon.isImageType = true;